export const getCARRecords = async () => {
  const conn_name = "crmwidgetconnection";

  const payload = {
    parameters: {},
    method: "GET",
    url: "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/CAR_PAR1",
    param_type: 1,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);

    // ✅ FIX: correctly extract the array of records
    const records = response.details?.statusMessage?.data || [];

    console.log("✅ Parsed CAR Records:", records);
    console.table(records);

    return records.map((item) => ({
      id: item.ID,
      name: item.CAR_Name,
      title: item.CAR_Name,
      carNumber: item.CAR_number,
      status: item.Status_Kanban || "Total CAR Open",
      issue:
        item.Describe_the_issue_or_problem_in_detail || "No issue provided",
      assignedTo: item.CAR_PAR_Assigned_to || "Unassigned",
      respondBy: item.Respond_by || "",
      CAR_Date: item.CAR_Date || "",
      ...item,
    }));
  } catch (error) {
    console.error("❌ Error fetching CAR records:", error);
    return [];
  }
};
